// pscm = platinum software cloud manager
// utility functions for pscm

/**
 * PSCM utilities
 * @name PSCM
 * @class
 */
class PSCM
{
	static isAdminUser(){
		return Grape.currentSession.roles.includes('accounts.admin');
	};

	static prompt(options){
		return new Promise((resolve, reject)=>{
			let new_options = Object.assign({}, options, {onClose: (ret)=>{
				if (options.onClose)
					options.onClose(ret)
				resolve(ret);
			}})
			Grape.alert_prompt(new_options);
		});
	};
}

window.PSCM = PSCM;
